import React, { Component } from "react";
import moment from "moment";
// import { Modal } from 'carbon-components-react';
import Modal from "@acadia-ui/modal";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import PlacementDataStore from "../../Flux/Stores/PlacementDataStore";
import PackagesDataStore from "../../Flux/Stores/PackagesDataStore";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "./ModalHelpers";
import { fetchParentData } from "../../Flux/Actions/ParentActions";
import { putSheetData } from "../../Flux/Actions/PlacementActions";
import "./modal.scss";
import ParentDataStore from "../../Flux/Stores/ParentDataStore";
import Loading from "../../Components/LoadingSpinner";
import Button from "@acadia-ui/button";
import "./NewPlacement.scss";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	chosenOptions: {},
	packageData: {},
	valueToCalculate: null,
	isFormDataValid: false
};

const formEl = "create_placement";

class NewPlacement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			keepModalOpen: false,
			metaData: {
				StartDate: props.metaData.StartDate ? moment(props.metaData.StartDate).format("YYYY/MM/DD") : null,
				EndDate: props.metaData.EndDate ? moment(props.metaData.EndDate).format("YYYY/MM/DD") : null
			},
			loading: false,
			...initialState
		};
	}

	ConvertToValidDateValue = (value) => {
		if (value) {
			const validDate = moment(this.props.value, "MM/DD/YYYY");
			return new Date(validDate);
		}
		return null;
	};

	componentDidMount() {
		this.props.newPlacement(this);
		PlacementDataStore.on("add_placement_error", this.handleErrors);
		PlacementDataStore.on("placement_success", this.handleSuccess);
		PlacementDataStore.on("placement__errors__reset", this.handleReset);
		ParentDataStore.on("parent_changed", this.handleParentChange);
		ParentDataStore.on("parentData__reset", this.handleParentReset);
		this.setInitialFormData();
	}

	parentChanged = (overrideValue = null) => {
		const defaultValue = overrideValue || PackagesDataStore.getDefaultValue();
		if (defaultValue !== null) {
			this.setPackageData(defaultValue);
			const { postData } = this.state;
			postData.ParentData = { ParentUniqueIdCode: defaultValue.value };
			this.setState({ postData });
			PackagesDataStore.resetDefaultValue();
		}
		if (PackagesDataStore.getNavigate()) {
			PackagesDataStore.setNavigate(false);
		}
	};

	setPackageData = (defaultValue) => {
		window.setTimeout(() => {
			if (defaultValue) {
				this.setState({ loading: true }, () => {
					const form = this.state.formData;
					form.ParentDescription = { disabled: false, value: defaultValue };
					this.setState({ formData: form });
					const filters = BookFiltersStore.getChoicesState();
					this.props.auditLevelData.forEach((auditLevel) => {
						if (auditLevel.AuditLevelName === "Placement") {
							filters.auditlevel = { value: auditLevel.AuditLevelID };
						}
					});
					const campaignUniqueIdCode = MasterCampaignsStore.getParentCampaignUniqueID();
					fetchParentData(filters, campaignUniqueIdCode, defaultValue.value, this.props.auditLevelID);
				});
			}
		}, 50);
	};

	componentDidUpdate() {
		this.isValidFormData();
	}

	componentWillUnmount() {
		PlacementDataStore.removeListener("placement_success", this.handleSuccess);
		PlacementDataStore.removeListener("add_placement_error", this.handleErrors);
		PlacementDataStore.removeListener("placement__errors__reset", this.handleReset);
		ParentDataStore.removeListener("parent_changed", this.handleParentChange);
		ParentDataStore.removeListener("parentData__reset", this.handleParentReset);
	}

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	handleParentReset = (callback) => {
		const ns = {
			...initialState,
			loading: false,
			metaData: {
				StartDate: this.props.metaData.StartDate ? moment(this.props.metaData.StartDate).format("YYYY/MM/DD") : null,
				EndDate: this.props.metaData.EndDate ? moment(this.props.metaData.EndDate).format("YYYY/MM/DD") : null
			},
			valueToCalculate: null
		};

		ns.formData = {};
		ns.formData.ParentDescription = { value: { label: "STANDALONE", value: "STANDALONE" } };
		ns.postData = {};

		this.setState({ loading: true }, () => {
			if (callback) {
				this.setState(
					{
						...initialState,
						loading: false,
						metaData: {
							StartDate: this.props.metaData.StartDate ? moment(this.props.metaData.StartDate).format("YYYY/MM/DD") : null,
							EndDate: this.props.metaData.EndDate ? moment(this.props.metaData.EndDate).format("YYYY/MM/DD") : null
						},
						valueToCalculate: null
					},
					callback()
				);
			} else {
				this.setState(ns, () => {
					UpdateStateHelper.matchParentValues(this, this.props.config);
				});
			}
		});
	};

	handleSearchOrder = (prepopulatedData = null) => {
		this.setState(
			{
				...initialState,
				loading: true,
				metaData: {
					StartDate: this.props.metaData.StartDate ? moment(this.props.metaData.StartDate).format("YYYY/MM/DD") : null,
					EndDate: this.props.metaData.EndDate ? moment(this.props.metaData.EndDate).format("YYYY/MM/DD") : null
				},
				...(prepopulatedData && { ...prepopulatedData })
			},
			() => {
				UpdateStateHelper.matchParentValues(this, this.props.config, () => {
					const ns = { formData: this.state.formData, postData: this.state.postData };
					ns.formData.ParentDescription = { value: { label: "Search Order", value: "Search Order" } };
					["PlacementData", "TaxonomyData", "MetaData"].forEach((bucketName) => {
						this.props.config[bucketName].forEach((dataKey) => {
							if (dataKey.Name === "BuyType") {
								const searchOption = dataKey.Options?.find((dataKey) => {
									return dataKey.OptionLabel === "Search";
								});
								if (searchOption) {
									ns.formData.BuyType = {
										disabled: true,
										parentName: dataKey.ParentName,
										value: { label: searchOption.OptionLabel, value: searchOption.OptionID }
									};
									ns.postData[bucketName] = {
										...(ns?.postData?.[bucketName] || {}),
										BuyType: searchOption.OptionLabel
									};
								}
							}
							if (dataKey.Name === "RateType") {
								const flatOption = dataKey.Options?.find((dataKey) => {
									return dataKey.OptionLabel === "Flat";
								});
								if (flatOption) {
									ns.formData.RateType = {
										disabled: true,
										parentName: dataKey.ParentName,
										value: { label: flatOption.OptionLabel, value: flatOption.OptionID }
									};
									ns.postData[bucketName] = {
										...(ns?.postData?.[bucketName] || {}),
										RateType: {
											dataKeyID: dataKey.ID,
											parentName: dataKey.ParentName,
											dataValue: {
												dataValueID: flatOption.OptionID
											}
										}
									};
								}
							}
						});
					});
					this.setState({ loading: false, ...ns });
				});
			}
		);
	};

	handleParentChange = () => {
		this.handleReset();
		const parentData = ParentDataStore.getParentData();
		if (parentData.PackageName_Friendly && parentData.PackageID) {
			this.setState({ packageData: { value: parentData.PackageID, label: parentData.PackageName_Friendly, packageType: parentData.PackageType } });
		}
		const configObjs = Object.entries(this.props.config);
		if (Object.keys(parentData).length === 0) {
			// Reset to initialState
			this.handleParentReset();
		} else {
			let { formData } = this.state;
			let { postData } = this.state;

			for (const dataBucket of configObjs) {
				// Process all the data buckets except Parent Data.
				if (dataBucket[0] !== "ParentData") {
					for (const field of dataBucket[1]) {
						if (field.Name === "Rate" || field.Name === "PlannedUnits" || field.Name === "Cost") {
							// Programmatic line items require a budget, so we need to clear out any budget related fields, which will trigger the save button validation and
							// force the user to fill them in
							if (parentData.PackageType === "Programmatic") {
								delete formData[field.Name];
								delete postData[dataBucket[0]][field.Name];
							} else {
								// Set Rate, Planned Unit, and Cost to 0.
								// There are only 7 Parameters accepted: see updateState below to match
								const postDataBucket = postData[dataBucket[0]] ? postData[dataBucket[0]] : {};
								Object.assign(postDataBucket, { [field.Name]: 0 });
								const value = 0;
								formData = {
									...formData,
									[field.Name]: {
										value,
										disabled: true
									}
								};
								postData = {
									...postData,
									[dataBucket[0]]: postDataBucket
								};
								// this.updateState(dataBucket[0], field.Name, 0, field.ID, field.DataType, false, true);
								// Only populate fields that exist in ParentData.
							}
						} else if (parentData.hasOwnProperty(field.Name) && parentData[field.Name] !== "") {
							let readOnly = false;
							if (field.IsReadOnly === true) {
								readOnly = true;
							}
							if (field.DataType === "Select") {
								if (field.Name === "PlatformSiteID") {
									let siteLabel = null;
									field.Options.forEach((site) => {
										if (site.OptionID === parentData[field.Name]) {
											siteLabel = site.OptionLabel;
										}
									});
									if (siteLabel !== null) {
										if (dataBucket[0] === "MetaData" || dataBucket[0] === "TaxonomyData") {
											let parentName = null;
											if (this.props.config && this.props.config[dataBucket[0]]) {
												this.props.config[dataBucket[0]].forEach((configField) => {
													if (field.Name === configField.Name) {
														if (field.ParentName !== null) {
															parentName = field.ParentName;
														}
													}
												});
											}
											const postDataBucket = postData[dataBucket[0]] ? postData[dataBucket[0]] : {};
											Object.assign(postDataBucket, {
												[field.Name]: {
													dataKeyID: field.ID,
													dataValue: {
														dataValueID: parentData[field.Name]
													},
													parentName
												}
											});
											const value = { value: parentData[field.Name], label: siteLabel };
											formData = {
												...formData,
												[field.Name]: {
													value,
													disabled: readOnly,
													parentName
												}
											};
											postData = {
												...postData,
												[dataBucket[0]]: postDataBucket
											};
										} else {
											const postDataBucket = postData[dataBucket[0]] ? postData[dataBucket[0]] : {};
											const value = { value: parentData[field.Name], label: siteLabel };
											Object.assign(postDataBucket, { [field.Name]: value.value });
											formData = {
												...formData,
												[field.Name]: {
													value,
													disabled: readOnly,
													parentName
												}
											};
											postData = {
												...postData,
												[dataBucket[0]]: postDataBucket
											};
										}
									}
								} else {
									let optionID = parentData[`${field.Name}ID`];
									const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);
									if (fieldItem.length > 0) {
										const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == parentData[field.Name]);
										if (optionItem.length > 0) {
											optionID = optionItem[0].OptionID;
										}
									}

									// Populate Drop Down Fields
									// There are only 7 Parameters accepted: see updateState below to match
									if (optionID != undefined && optionID > 0) {
										if (dataBucket[0] === "MetaData" || dataBucket[0] === "TaxonomyData") {
											let parentName = null;
											if (this.props.config && this.props.config[dataBucket[0]]) {
												this.props.config[dataBucket[0]].forEach((configField) => {
													if (field.Name === configField.Name) {
														if (field.ParentName !== null) {
															parentName = field.ParentName;
														}
													}
												});
											}
											const postDataBucket = postData[dataBucket[0]] ? postData[dataBucket[0]] : {};
											Object.assign(postDataBucket, {
												[field.Name]: {
													dataKeyID: field.ID,
													dataValue: {
														dataValueID: optionID
													},
													parentName
												}
											});
											const value = { value: optionID, label: parentData[field.Name] };
											formData = {
												...formData,
												[field.Name]: {
													value,
													disabled: readOnly,
													parentName
												}
											};
											postData = {
												...postData,
												[dataBucket[0]]: postDataBucket
											};
										} else {
											const postDataBucket = postData[dataBucket[0]] ? postData[dataBucket[0]] : {};
											const value = { value: optionID, label: parentData[field.Name] };
											Object.assign(postDataBucket, { [field.Name]: value.label });
											formData = {
												...formData,
												[field.Name]: {
													value,
													disabled: readOnly
												}
											};
											postData = {
												...postData,
												[dataBucket[0]]: postDataBucket
											};
										}
									}
								}
							} else {
								// Populate Free Text Feilds
								// There are only 7 Parameters accepted: see updateState below to match
								if (dataBucket[0] === "MetaData" || dataBucket[0] === "TaxonomyData") {
									const postDataBucket = postData[dataBucket[0]] ? postData[dataBucket[0]] : {};
									Object.assign(postDataBucket, {
										[field.Name]: {
											dataKeyID: field.ID,
											dataValueIfFreeForm: parentData[field.Name]
										}
									});
									const value = parentData[field.Name];
									formData = {
										...formData,
										[field.Name]: {
											value,
											disabled: readOnly
										}
									};
									postData = {
										...postData,
										[dataBucket[0]]: postDataBucket
									};
								} else {
									const postDataBucket = postData[dataBucket[0]] ? postData[dataBucket[0]] : {};
									const value = parentData[field.Name];
									Object.assign(postDataBucket, { [field.Name]: value });
									formData = {
										...formData,
										[field.Name]: {
											value,
											disabled: readOnly
										}
									};
									postData = {
										...postData,
										[dataBucket[0]]: postDataBucket
									};
								}
							}
						}
					}
				}
			}
			const ParentData = { ParentUniqueIdCode: parentData.PackageID };
			postData.ParentData = ParentData;

			const campaignStart = this.props.metaData.StartDate ? moment(this.props.metaData.StartDate) : null;
			const campaignEnd = this.props.metaData.EndDate ? moment(this.props.metaData.EndDate) : null;
			const packageStart = parentData.StartDate ? moment(parentData.StartDate) : null;
			const packageEnd = parentData.EndDate ? moment(parentData.EndDate) : null;

			// Use the more restrictive of campaign vs package date bounds
			const effectiveStart = packageStart && campaignStart ? moment.max(campaignStart, packageStart) : packageStart || campaignStart;
			const effectiveEnd = packageEnd && campaignEnd ? moment.min(campaignEnd, packageEnd) : packageEnd || campaignEnd;

			const metaData = {
				StartDate: effectiveStart ? effectiveStart.format("YYYY/MM/DD") : null,
				EndDate: effectiveEnd ? effectiveEnd.format("YYYY/MM/DD") : null
			};

			this.setState({ postData, formData, metaData, loading: false, valueToCalculate: null, isFormDataValid: false });
		}
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;
			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;

			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
			if (postData.PlacementData) {
				postData.PlacementData.MasterCampaignID = this.props.metaData.MasterCampaignID;
				postData.PlacementData.CampaignID = this.props.metaData.CampaignUniqueIDCode;
				if (this.props.metaData.Budget === null || this.props.metaData.Budget === 0) {
					postData.PlacementData.Cost = 0;
				}
			} else if (!postData.PlacementData) {
				postData.PlacementData = {};
				postData.PlacementData.MasterCampaignID = this.props.metaData.MasterCampaignID;
				postData.PlacementData.CampaignID = this.props.metaData.CampaignUniqueIDCode;
				if (this.props.metaData.Budget === null || this.props.metaData.Budget === 0) {
					postData.PlacementData.Cost = 0;
				}
			}
			if (postData.ParentData) {
				if (this.state.formData.ParentDescription) {
					if (this.state.formData.ParentDescription.value.label === "STANDALONE" && this.state.formData.ParentDescription.value.value === "STANDALONE") {
						delete postData.ParentData;
					}
				}
			}

			if (this.state.formData?.ParentDescription?.value?.label === "Search Order" && this.state.formData?.ParentDescription?.value?.value === "Search Order") {
				delete postData.ParentData;
				postData.PlacementData.PackageType = "Search Order";
			}

			/* Config will hold the ID's of the filters */
			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				PlatformID,
				AuditLevelID,
				MasterRegionCode: contextValues?.region?.name,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};
			return formSubmissionObj;
		}
		const type = "newPlacement";
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true, loading: false }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors, type);
		});
	};

	sendPostObject = (newRowObj) => {
		const postObject = this.formDataObjForPost(newRowObj);
		if (postObject) {
			const updatedData = putSheetData(postObject);
		}
	};

	setInitialFormData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		for (const dataBucket of configObjs) {
			if (dataBucket[0] != "ChildData") {
				for (const field of dataBucket[1]) {
					if (field.Name && field?.FieldType != "Hidden") {
						if (field.Name == "ParentDescription") {
							this.state.formData[field.Name] = { value: { label: "STANDALONE", value: "STANDALONE" }, disabled: false, parentName: null };
							this.autoSelect();
						} else {
							this.state.formData[field.Name] = { disabled: false, parentName: null, value: "" };
						}
					}
				}
			}
		}
	};

	isValidFormData = () => {
		const { formData } = this.state;
		const { packageData } = this.state;
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = !["Rate", "Cost", "PlannedUnits"].includes(key) ? formData[key].disabled : false;
				const isStandalone = formData?.ParentDescription?.value?.value === "STANDALONE";
				const isProgrammatic = packageData?.packageType === "Programmatic";
				if (
					["Rate", "Cost", "PlannedUnits"].includes(key) &&
					(["Flat", "Free", "Added Value"].includes(formData.RateType?.value?.label) || (!isStandalone && !isProgrammatic))
				) {
					if ((value === "" || value == null || value == undefined) && !isDisabled) {
						isValid = false;
					}
				} else if ((value == "" || value == null || value == undefined || value == "0.00" || value === 0) && !isDisabled) {
					isValid = false;
				}
			}
		}
		if (isValid === true) {
			const visibleFields = [];
			Object.keys(this.props.config).forEach((bucket) => {
				if (["PlacementData", "MetaData", "TaxonomyData"].includes(bucket)) {
					this.props.config[bucket].forEach((dataKey) => {
						if (dataKey.IsSummarizedHeader === true && dataKey.FieldType !== "Hidden") {
							visibleFields.push(dataKey.Name);
						}
					});
				}
			});
			const filledOutFields = Object.keys(formData);
			isValid = !visibleFields.find((field) => {
				return !filledOutFields.includes(field);
			});
		}

		if (this.state.isFormDataValid !== isValid) {
			this.setState({ isFormDataValid: isValid });
		}
		return isValid;
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled, disableDelete = false) => {
		if (value) {
			if (value.label === "STANDALONE" && value.value === "STANDALONE") {
				const postData = {};
				this.setState({
					formData: { ParentDescription: { disabled: false, value: { label: value.label, value: value.value } } },
					postData
				});
			} else {
				UpdateStateHelper.update(dataConfig, name, value, id, dataType, calc, formEl, this, disabled, this.props.config, disableDelete, this.isValidFormData);
			}
		} else {
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, calc, formEl, this, disabled, this.props.config, disableDelete, this.isValidFormData);
		}
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				this.setState({ keepModalOpen: false });
				e.preventDefault();
				this.sendPostObject(this.state.formData);
			});
		}
	};

	handleSuccess = (e) => {
		// this.setState({ loading: false });
		// this.props.updateCounts("Placement");
		// this.props.updateMetaData();
		this.props.refresh(this.state.keepModalOpen, this.state.formData?.ParentDescription?.value);

		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Placement added successfully." timed={5000} />);
	};

	autoSelect = () => {
		if (this.props.newPlacement) {
			this.setState({ formData: { ParentDescription: { value: { label: "STANDALONE", value: "STANDALONE" } } } });
		}
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = PlacementDataStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const placementErrors = errors;
				this.setState({ errors: placementErrors, showErrors: true }, () => {
					const type = "newPlacement";
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Placement could not be added." />);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		this.handleParentReset();
		ErrorHelpers.resetErrors(formEl);
		this.setState({ open: !this.state.open, isFormDataValid: false });
	};

	openModal = (prepopulatedData) => {
		ErrorHelpers.resetErrors(formEl);
		this.setState({ open: true, isFormDataValid: false, ...(prepopulatedData && { ...prepopulatedData }) });
	};

	createAnother = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				this.setState({ keepModalOpen: true });

				if (this.state.formData.ParentDescription && this.state.formData.ParentDescription.value.label === "STANDALONE") {
					this.handleReset();
					const standaloneData = this.state.postData;
					standaloneData.ParentDescription = {};
					this.setState({ postData: standaloneData });
				} else {
					this.handleReset();
				}
				this.sendPostObject(this.state.formData);

				e.preventDefault();
			});
		}
	};
	/* END */

	setLoading = (callback) => {
		this.setState({ loading: true }, () => {
			callback();
		});
	};

	updateCalculatedField = (value) => {
		this.setState({ valueToCalculate: value });
	};

	render() {
		const isDisabled = this.state.loading ? "disabledModal" : "";
		const parentData = this.props.config.ParentData;
		if (parentData) {
			parentData.forEach((p) => {
				let standalone = false;
				if (p.Options) {
					p.Options.forEach((option) => {
						if (option.OptionID === "STANDALONE" && option.OptionLabel === "STANDALONE") {
							standalone = true;
						}
					});
				}
				if (standalone === false) {
					p.Options.push({ OptionID: "STANDALONE", OptionLabel: "STANDALONE" });
				}
			});
		}

		const data = JSON.parse(JSON.stringify(this.props.config));
		const DNU_index = data?.ParentData?.findIndex((el) => el.Name == "IsDoNotUse");
		if (DNU_index >= 0) {
			data?.ParentData?.splice(DNU_index, 1);
		}

		return (
			<>
				<Modal
					id={formEl}
					className={`new--placement ${isDisabled}`}
					heading="Add Placement"
					description={`Complete the form to create a ${this.state.packageData?.packageType === "Programmatic" ? "Line Item" : ""} Placement. Choose 'Add' to save, or 'Create and Add Another' to continue with placements.`}
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsLeft: (
							<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-add-placement">
								Cancel
							</Button>
						),
						actionsRight: (
							<>
								<Button
									className="second-button"
									display="secondary"
									disabled={!this.state.isFormDataValid}
									onClick={this.createAnother}
									data-tracking-id-alt="create-add-another-placement"
								>
									Create and Add Another
								</Button>
								<Button
									className="third-button"
									display="primary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-add-placement"
								>
									Add
								</Button>
							</>
						)
					}}
				>
					{this.state.loading && <Loading className="modalLoading" />}

					{!this.state.loading && (
						<form className="newPlacementForm" autoComplete="off">
							<div className="form__group__container _m-t--10 _m-b--10">
								<FormBuilderV2
									type="newPlacement"
									data={data}
									configName="NewPlacement"
									onUpdate={this.updateState}
									autoSelect={this.props.newPlacement && this.autoSelect}
									state={this.state}
									setLoading={this.setLoading}
									handleStandalone={(...args) => {
										this.handleParentReset(...args);
									}}
									handleSearchOrder={this.handleSearchOrder}
									// handleStandalone={(...args) => this.handleParentReset(...args)}
									rerenderDP={true}
									updateCalculatedField={this.updateCalculatedField}
									formEl={formEl}
									parentRef={this}
									metaData={this.props.metaData}
									auditLevelID={this.props.auditLevelID}
								/>
							</div>
							{this.state.showErrors && <div id="errors__container" />}
						</form>
					)}
				</Modal>
			</>
		);
	}
}

export default NewPlacement;
